import { apiService } from './api';

export interface CreateMercadoPagoPreferenceRequest {
  productId: string;
  productName: string;
  price: string;
  currency: string;
  quantity?: number;
  orderId?: string;
}

export interface MercadoPagoPreferenceResponse {
  preferenceId: string;
  initPoint: string;
  sandboxInitPoint: string;
  orderId?: string;
}

/**
 * Crea una preferencia de pago en MercadoPago
 */
export const createMercadoPagoPreference = async (
  data: CreateMercadoPagoPreferenceRequest
): Promise<MercadoPagoPreferenceResponse> => {
  try {
    // Usar apiService que ya maneja la autenticación JWT
    return await apiService.post<MercadoPagoPreferenceResponse>(
      '/payments/mercadopago/create-preference',
      data
    );
  } catch (error: any) {
    console.error('Error creating MercadoPago preference:', error);
    throw new Error(
      error.message || 'Error al crear la preferencia de pago en MercadoPago'
    );
  }
};

/**
 * Redirige al usuario a MercadoPago Checkout
 */
export const redirectToMercadoPago = async (
  data: CreateMercadoPagoPreferenceRequest
): Promise<void> => {
  try {
    const { initPoint, sandboxInitPoint } = await createMercadoPagoPreference(data);

    // Usar sandbox en desarrollo, initPoint en producción
    const checkoutUrl = process.env.NODE_ENV === 'production' ? initPoint : sandboxInitPoint;
    
    window.location.href = checkoutUrl;
  } catch (error) {
    console.error('Error redirecting to MercadoPago:', error);
    throw error;
  }
};

const mercadopagoService = {
  createMercadoPagoPreference,
  redirectToMercadoPago,
};

export default mercadopagoService;